import type { OrgFeaturesList } from '../types';

type OrgModule = { id: string; label: string };

export class OrgModel {
  features?: OrgFeaturesList[];

  modules?: OrgModule[];
}
